/* Rataa: show approximate USD prices to international visitors.
   Display only. Checkout still charges LKR. Change RATE to update.
   Handles "21,000 LKR", "LKR 21,000.00" and "Rs. 21,000".
   Elements marked data-no-usd are left alone. */
(function () {
  var RATE = 350; // LKR per 1 USD
  window.RATAA_USD_RATE = RATE;
  var cfg = window.RATAA_INTL_CAP || {};
  var q = location.search;
  var on = cfg.enabled;
  if (/[?&]cap_test=1/.test(q)) on = true;
  if (/[?&]cap_test=0/.test(q)) on = false;
  if (!on) return;

  var NUM = '(\\d[\\d,]*(?:\\.\\d+)?)';
  var RE = new RegExp('(?:LKR|Rs\\.?)[\\s\\u00a0]*' + NUM + '|' + NUM + '[\\s\\u00a0]*LKR', 'g');
  var HAS = /LKR|Rs\.?[\s ]*\d/;
  var busy = false;

  function usd(n) {
    return 'USD ' + Math.round(n / RATE).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function convertNode(node) {
    var t = node.nodeValue;
    if (!t || !HAS.test(t)) return false;
    var out = t.replace(RE, function (m, a, b) {
      var v = parseFloat(String(a || b).replace(/,/g, ''));
      return isNaN(v) ? m : usd(v);
    });
    if (out !== t) {
      node.nodeValue = out;
      var p = node.parentElement;
      if (p) p.setAttribute('data-usd-price', '1');
      return true;
    }
    return false;
  }

  function walk(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var pe = n.parentElement;
        if (!pe) return NodeFilter.FILTER_REJECT;
        var tag = pe.tagName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'TEXTAREA') return NodeFilter.FILTER_REJECT;
        if (pe.closest && pe.closest('[data-no-usd]')) return NodeFilter.FILTER_REJECT;
        return n.nodeValue && HAS.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [], n;
    while ((n = w.nextNode())) nodes.push(n);
    nodes.forEach(convertNode);
  }

  function addNote() {
    if (document.getElementById('rataa-usd-note')) return;
    var first = document.querySelector('main [data-usd-price]');
    if (!first || first.closest('#cart-drawer')) return;
    var note = document.createElement('div');
    note.id = 'rataa-usd-note';
    note.style.cssText = 'font-size:12px;opacity:.7;margin-top:4px;line-height:1.4;';
    note.textContent = 'Approximate price in US dollars. You will be charged in Sri Lankan rupees (LKR) at checkout.';
    first.insertAdjacentElement('afterend', note);
  }

  function run() {
    if (busy) return;
    busy = true;
    try { walk(document.body); addNote(); } catch (e) {}
    busy = false;
  }

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 30); }

  function start() {
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
